<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/hrdata' }">人资系统</el-breadcrumb-item>
        <el-breadcrumb-item>个人中心</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-row v-if="tabName == null">
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="$router.push('/workflow/application')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #67c23a;">
              <CirclePlus />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>系统业务申请</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="pageChange('个人考勤')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #e6a23c;">
              <Search />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>个人考勤查询</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="pageChange('月度薪资')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: #f56c6c;">
              <Money />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>月度薪资</p>
          </div>
        </div>
      </el-col>
      <el-col :xs="12" :sm="6" :md="3" :lg="3" :xl="3">
        <div class="el-result" @click="pageChange('个人资料')">
          <div class="el-result__icon">
            <el-icon style="font-size: 3em; color: rgb(194, 0, 232);">
              <DocumentChecked />
            </el-icon>
          </div>
          <div class="el-result__title">
            <p>个人资料</p>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-descriptions v-if="tabName == '月度薪资'" title="月度薪资查询" direction="horizontal" border :column="1"
      label-width="120px" style="margin-top: 20px">
      <el-descriptions-item label="月份" label-align="right">
        <el-date-picker v-model="month" type="month" placeholder="年月" @change="pageChange()"
          style="max-width: 180px;" />
      </el-descriptions-item>
      <el-descriptions-item label="姓名" label-align="right">
        <template #label>
          <div class="cell-item">
            <el-icon>
              <user />
            </el-icon>
            姓名
          </div>
        </template>
        {{ salary.employeeName }}
      </el-descriptions-item>
      <el-descriptions-item label="公司" label-align="right">{{ salary.companyName }}</el-descriptions-item>
      <el-descriptions-item label="部门" label-align="right">{{ salary.departmentName }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item label="基础工资" label-align="right">{{ salary.basicSalaryFee }}</el-descriptions-item>
      <el-descriptions-item label="岗位工资" label-align="right">{{ salary.basicPositionFee }}</el-descriptions-item>
      <el-descriptions-item label="绩效工资" label-align="right">{{ salary.basicPerformanceFee }}</el-descriptions-item>
      <el-descriptions-item label="保密费" label-align="right">{{ salary.basicConfidentialFee }}</el-descriptions-item>
      <el-descriptions-item label="津补贴" label-align="right">{{ salary.basicAllowanceFee }}</el-descriptions-item>
      <el-descriptions-item label="基础工资合计" label-align="right">{{ salary.basicTotalFee }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item label="绩效奖金" label-align="right">{{ salary.otherBonusFee }}</el-descriptions-item>
      <el-descriptions-item label="其他收入" label-align="right">{{ salary.otherIncomeFee }}</el-descriptions-item>
      <el-descriptions-item label="加班费" label-align="right">{{ salary.overtimeFee }}</el-descriptions-item>
      <el-descriptions-item label="实发提成" label-align="right">{{ salary.commissionFee }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item label="行政缺勤小时数" label-align="right">{{ salary.absenceHours }}</el-descriptions-item>
      <el-descriptions-item label="考勤扣款" label-align="right">{{ salary.attendanceDeductionFee }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item label="其他补贴" label-align="right">{{ salary.otherAllowanceFee }}</el-descriptions-item>
      <el-descriptions-item label="其他扣款" label-align="right">{{ salary.otherDeductionFee }}</el-descriptions-item>
      <el-descriptions-item label="其他代扣款" label-align="right">{{ salary.withholdingFee }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item label="应发工资" label-align="right">{{ salary.grossSalaryFee }}</el-descriptions-item>
      <el-descriptions-item label="个人社保" label-align="right">{{ salary.personalSocialSecurityFee
      }}</el-descriptions-item>
      <el-descriptions-item label="个人住房公积金" label-align="right">{{ salary.personalHousingFundFee
      }}</el-descriptions-item>
      <el-descriptions-item label="纳税所得额" label-align="right">{{ salary.taxableIncomeFee }}</el-descriptions-item>
      <el-descriptions-item label="专项扣除" label-align="right">{{ salary.specialDeductionFee }}</el-descriptions-item>
      <el-descriptions-item label="个人所得税" label-align="right">{{ salary.incomeTaxFee }}</el-descriptions-item>
      <el-descriptions-item label="实发工资" label-align="right">{{ salary.netSalaryFee }}</el-descriptions-item>
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item label="对公报销" label-align="right">{{ salary.reimbursementFee }}</el-descriptions-item>
      <el-descriptions-item label="其他发放" label-align="right">{{ salary.privatePaymentFee }}</el-descriptions-item>

    </el-descriptions>

    <el-descriptions v-if="tabName == '个人考勤'" title="个人考勤查询" direction="horizontal" border :column="1"
      label-width="120px" style="margin-top: 20px">
      <el-descriptions-item label="月份" label-align="right">
        <el-date-picker v-model="month" type="month" placeholder="年月" @change="pageChange()"
          style="max-width: 180px;" />
      </el-descriptions-item>
      <!-- <el-descriptions-item label="姓名" label-align="right">
        <template #label>
          <div class="cell-item">
            <el-icon>
              <user />
            </el-icon>
            姓名
          </div>
        </template>
        {{ signDaily.姓名 }}
      </el-descriptions-item> -->
      <el-descriptions-item label=""></el-descriptions-item>

      <el-descriptions-item v-for="(value,key) in signDaily" :label="key" label-align="right" >
        {{ value }}
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions v-if="tabName == '个人资料'" title="个人资料" direction="horizontal" border :column="1"
      label-width="120px" style="margin-top: 20px">
      <!-- <el-descriptions-item v-for="(value,key) in person" :label="key" label-align="right" >
        {{ value }}
      </el-descriptions-item> -->
      
      <el-descriptions-item label="公司" label-align="right">{{ person.companyName }}</el-descriptions-item>
      <el-descriptions-item label="部门" label-align="right">{{ person.departmentName }}</el-descriptions-item>
      <el-descriptions-item label="姓名" label-align="right">{{ person.realName }}</el-descriptions-item>
      <el-descriptions-item label="性别" label-align="right">{{ person.gender }}</el-descriptions-item>
      <el-descriptions-item label="角色权限" label-align="right">{{ person.roles }}</el-descriptions-item>

    </el-descriptions>

    <el-button icon="Back" type="primary" v-if="tabName != null" @click="tabName = null"
      style="margin-top:20px; margin-left: 10px; position:absolute; bottom: 30px;">
      返 回
    </el-button>
  </el-card>

</template>

<script>
export default {
  name: "personal",
  components: {},
  data() {
    return {
      tabName: null,
      month: null,
      salary: {},
      signDaily: {},
      person: {}
    };
  },
  mounted() {
    if (this.$route.query.tabName)
      this.tabName = this.$route.query.tabName;

    const currentDate = new Date();
    if (currentDate.getDate() < 15) {
      //如果当前日期小于15号，则显示上个月
      this.month = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
    } else {
      //否则显示当前月
      this.month = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    }
  },
  methods: {
    pageChange(tab) {
      if (tab) {
        this.tabName = tab;
      }

      let year = this.month.getFullYear();
      let month = this.month.getMonth() + 1;

      if (this.tabName == '月度薪资') {
        this.salary = {};
        this.$kaung.fetch({ url: `/HrSalary/Personal?year=${year}&month=${month}` }).then((res) => {
          this.$message({ message: res.content, type: res.type });
          if (res.code === 200) {
            this.salary = res.data;
          }
        });
      }
      else if (this.tabName == '个人考勤') {
        this.signDaily = {};
        this.$kaung.fetch({ url: `/HrSignLog/SignMonthDaily?year=${year}&month=${month}&queryType=1` }).then((res) => {
          this.$message({ message: res.content, type: res.type });
          if (res.code === 200 && res.data.length ==1) {
            this.signDaily = res.data[0];
          }
        });
      }
      else if (this.tabName == '个人资料') {
        this.person = this.$store.getters.getUserInfo;
      }
    },
  },
};
</script>
<style scoped>
.el-result {
  margin: 0 12px;
  border: 1px solid #fff;
  --el-result-padding: 20px;
  background: #fcfcfc;
}

.el-result:hover {
  border: 1px solid #ccc;
  border-radius: 10px;
  cursor: pointer;
}
</style>